export default __webpack_public_path__ + "static/dsc9240-1024x683-07093186c6d2bd3bcc6f14004392ccce.jpg";